import Vue from 'vue';

const NavigationBus = new Vue();

export default NavigationBus;
